import i18n from '@/plugins/i18n';

// Helper per accedere alle traduzioni senza l'istanza Vue (vm)
const $t = (key) => i18n.global.t(key);
export const initialState = {
  aclRules: [],
  appMenu: [],
};

export default {
  namespaced: true,
  state: () => ({
    aclRules: [],
    appMenu: [],
  }),
  mutations: {
    RESET_STATE_ACL(state) {
      Object.assign(state, initialState);
    },
    restoreState(state, newState) {
      Object.assign(state, newState);
    },
    setAclRules(state, aclRules) {
      state.aclRules = aclRules;
    },
    setAppMenu(state, appMenu) {
      state.appMenu = appMenu;
    },
  },
  getters: {
    appMenu: (state) => {
      return state.appMenu != null ? state.appMenu : [];
    },
    aclRules: (state) => {
      return state.aclRules != null ? state.aclRules : [];
    },
    roleAgente: () => {
      return 'selectioage';
    },
    roleCliente: () => {
      return 'selectiocli';
    },
    roleBroker: () => {
      return 'selectiobro';
    },
    roleBackoffice: () => {
      return 'selectiodir';
    },
    roleGroup: () => {
      return 'selectio-capo-gruppo';
    },
    companyItalia: () => {
      return '328';
    },
    companySpagna: () => {
      return '995';
    },
    companyGrecia: () => {
      return '900';
    },
  },
  actions: {
    // Rimosso { vm } dai parametri, ora usa l'helper $t
    createAclRules(context, { user }) {
      if (!(user != null && user.role != null && user.companyCode != null)) {
        console.error('Dati utente incompleti per ACL', user);
        return;
      }

      context.state.aclRules.length = 0;

      // Passiamo solo user, vm non serve più
      app_Menu(context, user);
      appTopBar_ACL(context, user);
      buyersList_ACL(context, user);
      createPortfolio_ACL(context, user);
      managePortfolio_ACL(context, user);
      manageBuyers_ACL(context, user);
      manageIconPortfolios_ACL(context, user);
      iconPortfolios_ACL(context, user);
      tars_ACL(context, user);
      userPreference_ACL(context, user);
    },
  },
};

// Funzione modificata per usare $t invece di $t
function app_Menu(context, user) {
  const appMenu = [];
  const homePage = {
    label: 'Home Page',
    icon: 'pi pi-fw pi-home',
    items: [
      { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
    ],
  };
  const riskAnalysis = {
    label: $t('riskanaysis.label'),
    icon: 'fa fa-fw fa-eye',
    items: [
      { label: $t('riskgeographic.label'), icon: 'fa fa-fw fa-globe', to: '/risk_geographic' },
      { label: $t('risksectors.label'), icon: 'fa fa-fw fa-briefcase', to: '/risk_sectors' },
      { label: $t('payments.label'), icon: 'fa fa-fw fa-money', to: '/payments' },
    ],
  };
  const buyers = {
    label: $t('buyers.label'),
    icon: 'fa fa-fw fa-users',
    items: [
      { label: $t('buyerslist.label'), icon: 'fa fa-fw fa-archive', to: '/buyers_list' },
    ],
  };

  const admin = {
    label: 'Admin',
    icon: 'fa fa-fw fa-wrench',
    items: [
      { label: $t('manageportfolio.label'), icon: 'fa fa-fw fa-archive', to: '/manage_portfolio' },
    ],
  };

  appMenu.push(homePage, riskAnalysis, buyers, admin);

  const salemanToolkit = {
    label: 'Salesman Toolkit',
    icon: 'fa fa-fw fa-briefcase',
    items: [
      { label: 'URBA DEMO', icon: 'fa fa-fw fa-external-link', to: '/icon_demo' },
      { label: 'Selectio Insured Demo', icon: 'fa fa-fw fa-external-link', to: '/insured_demo' },
    ],
  };

  if (user.role === context.getters.roleBackoffice && user.companyCode === context.getters.companyItalia) {
    admin.items.push(
      { label: $t('menu.providerContracts'), icon: 'pi pi-book', to: '/provider-contracts' },
      { label: $t('gestioneacquisti.label'), icon: 'fa fa-fw fa-archive', to: '/gestione_acquisti' },
      {
        label: $t('portfolio.apiBusinessInformation'),
        icon: 'fa fa-fw fa-archive',
        to: '/manage_api_contracts',
      },
      { label: $t('buyerExclusions.menuLabel'), icon: 'fa fa-fw fa-ban', to: '/manage_buyer_exclusions' },
      { label: $t('menu.statistics'), icon: 'pi pi-chart-line', to: '/statistics' },
      { label: $t('menu.SFTP'), icon: 'pi pi-folder-open', to: '/SFTP' },
    );
  }

  if (user.role === context.getters.roleAgente) {
    admin.items.push(
      { label: $t('menu.statistics'), icon: 'pi pi-chart-line', to: '/statistics' },
    );
  }

  if ((user.role === context.getters.roleBackoffice &&
      user.companyCode === context.getters.companySpagna) ||
    (user.role === context.getters.roleBackoffice &&
      user.companyCode === context.getters.companyGrecia)
  ) {
    admin.items.push(
      { label: $t('gestioneacquisti.label'), icon: 'fa fa-fw fa-archive', to: '/gestione_acquisti' },
      { label: $t('portfolio.apiBusinessInformation'), icon: 'fa fa-fw fa-archive', to: '/manage_api_contracts' },
      { label: $t('buyerExclusions.menuLabel'), icon: 'fa fa-fw fa-ban', to: '/manage_buyer_exclusions' },
      { label: $t('menu.statistics'), icon: 'pi pi-chart-line', to: '/statistics' },
    );
  }

  if (user.role === context.getters.roleBackoffice || user.role === context.getters.roleAgente) {
    salemanToolkit.items.push({ label: 'Documenti', icon: 'fa fa-fw fa-external-link', to: '/tars' });
    appMenu.push(salemanToolkit);
  }
  if (user.role === context.getters.roleBroker) {
    appMenu.push(salemanToolkit);
  }

  if (user.companyCode === context.getters.companyItalia) {
    riskAnalysis.items.push({ label: $t('economics.label'), icon: 'fa fa-fw fa-line-chart', to: '/economics' });
  }
  context.commit('setAppMenu', appMenu);
}

// ... Il resto delle funzioni (appTopBar_ACL, buyersList_ACL, ecc.) rimangono invariate ...
// Assicurati di copiare le funzioni rimanenti dal tuo file originale qui sotto.

function appTopBar_ACL(context, user) {
  const aclRules = context.state.aclRules;
  if (user.role === context.getters.roleCliente || user.role === context.getters.roleGroup) {
    aclRules.push({ elementId: 'AppTopbar.createPortfolio', visible: false });
    aclRules.push({ elementId: 'AppTopbar.listaPortafogli', visible: false });
    aclRules.push({ elementId: 'AppTopbar.unmatchedbuyers', visible: false });
  }
  if (user.role === context.getters.roleBroker) {
    aclRules.push({ elementId: 'AppTopbar.createPortfolio', visible: false });
    aclRules.push({ elementId: 'AppTopbar.exportPortfolio', visible: false });
    aclRules.push({ elementId: 'AppTopbar.listaPortafogli', visible: false });
    aclRules.push({ elementId: 'AppTopbar.unmatchedbuyers', visible: false });
  }
  context.commit('setAclRules', aclRules);
}

function buyersList_ACL(context, user) {
  const aclRules = context.state.aclRules;
  if (user.role === context.getters.roleBroker) {
    aclRules.push({ elementId: 'BuyersList.downloadBuyers', clickable: false });
  }
  context.commit('setAclRules', aclRules);
}

function createPortfolio_ACL(context, user) {
  const aclRules = context.state.aclRules;
  if (user.role === context.getters.roleAgente) {
    aclRules.push({ elementId: 'CreatePortfolio.priority', visible: true, editable: false });
    aclRules.push({ elementId: 'CreatePortfolio.agencyCode', visible: true, editable: false });
    aclRules.push({ elementId: 'CreatePortfolio.portfolioType', visible: true, editable: false });
    aclRules.push({ elementId: 'CreatePortfolio.selectioInsured', visible: true, editable: false });
    aclRules.push({ elementId: 'CreatePortfolio.policyNumbers', visible: true, editable: false });
    aclRules.push({ elementId: 'CreatePortfolio.contractDC', visible: true, editable: false });
    aclRules.push({ elementId: 'CreatePortfolio.startingDate', visible: true, editable: false });
    aclRules.push({ elementId: 'CreatePortfolio.contractExpiration', visible: true, editable: false });
    aclRules.push({ elementId: 'CreatePortfolio.endingDate', visible: true, editable: false });
  }
  context.commit('setAclRules', aclRules);
}

function managePortfolio_ACL(context, user) {
  const aclRules = context.state.aclRules;

  if ((user.companyCode === context.getters.companySpagna) || (user.companyCode === context.getters.companyGrecia)) {
    aclRules.push({ elementId: 'CreatePortfolio.contractDC', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.selectioInsured', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.iconContract', visible: false, editable: false });
    //  aclRules.push({ elementId: 'ManagePortfolio.nettunoContract', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contractDC', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.buttonDeletePortfolio', visible: false, editable: false });
  }

  if (user.role !== 'selectiodir')
    aclRules.push({ elementId: 'ManagePortfolio.downloadDeletedBuyers', visible: false, clickable: false });

  if (user.role === context.getters.roleAgente) {
    aclRules.push({ elementId: 'ManagePortfolio.priority', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contract', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.portfolioType', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.agencyCode', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contractRenewal', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.policyNumbers', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contractDC', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.statues', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.userApi', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.emailApi', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.startingDate', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.endingDate', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contractExpiration', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.buttonDeletePortfolio', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.portfolioFlags', visible: true, editable: false });
  }
  if (user.role === context.getters.roleCliente || user.role === context.getters.roleGroup) {
    aclRules.push({ elementId: 'ManagePortfolio.priority', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.customer', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.agencyCode', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.maxBuyers', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.selectioInsured', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.policyNumbers', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contractDC', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.portfolioType', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contract', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.atRating', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.advancedOpinion', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contractRenewal', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.statues', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.templateCode', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.customerCode', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.userApi', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.emailApi', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.startingDate', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.endingDate', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contractExpiration', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.buttonDeletePortfolio', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.riskLevel', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.dra', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.latePIndex', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.claimSeverity', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.tipoValDra', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.portfolioFlags', visible: false, editable: false });
  }
  if (user.role === context.getters.roleBroker) {
    aclRules.push({ elementId: 'ManagePortfolio.priority', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.downloadTemplate', visible: true, clickable: false });
    aclRules.push({ elementId: 'ManagePortfolio.customer', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.agencyCode', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.maxBuyers', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.selectioInsured', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.policyNumbers', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contractDC', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.portfolioType', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contract', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.atRating', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.advancedOpinion', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contractRenewal', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.statues', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.templateCode', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.customerCode', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.userApi', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.emailApi', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.startingDate', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.endingDate', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.contractExpiration', visible: true, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.buttonDeletePortfolio', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.riskLevel', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.dra', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.latePIndex', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.claimSeverity', visible: false, editable: false });
    aclRules.push({ elementId: 'ManagePortfolio.tipoValDra', visible: false, editable: false });
  }
  context.commit('setAclRules', aclRules);
}

function manageBuyers_ACL(context, user) {
  const aclRules = context.state.aclRules;
  if (user.role === context.getters.roleBackoffice) {
    aclRules.push({ elementId: 'ManageBuyers.inputTextDivision', visible: true, editable: true });
    aclRules.push({ elementId: 'ManageBuyers.buttonDivision', visible: false, editable: false });
  }
  if (user.role === context.getters.roleAgente) {
    aclRules.push({ elementId: 'ManageBuyers.easynumber', visible: true, editable: false });
    aclRules.push({ elementId: 'ManageBuyers.division', visible: true, editable: false });
    aclRules.push({ elementId: 'ManageBuyers.inputTextDivision', visible: false, editable: false });
    aclRules.push({ elementId: 'ManageBuyers.buttonDivision', visible: true, editable: true });
  }
  if (user.role === context.getters.roleCliente || user.role === context.getters.roleGroup) {
    aclRules.push({ elementId: 'ManageBuyers.easynumber', visible: true, editable: false });
    aclRules.push({ elementId: 'ManageBuyers.division', visible: true, editable: false });
    aclRules.push({ elementId: 'ManageBuyers.inputTextDivision', visible: false, editable: false });
    aclRules.push({ elementId: 'ManageBuyers.buttonDivision', visible: true, editable: true });
  }
  if (user.role === context.getters.roleBroker) {
    aclRules.push({ elementId: 'ManageBuyers.easynumber', visible: true, editable: false });
    aclRules.push({ elementId: 'ManageBuyers.division', visible: true, editable: false });
    aclRules.push({ elementId: 'ManageBuyers.inputTextDivision', visible: false, editable: false });
    aclRules.push({ elementId: 'ManageBuyers.buttonDivision', visible: true, editable: true });
  }
  context.commit('setAclRules', aclRules);
}

function manageIconPortfolios_ACL(context, user) {
  const aclRules = context.state.aclRules;
  if (user.role === context.getters.roleAgente) {
    aclRules.push({ elementId: 'ManageIconPortfolios.agencyCode', visible: true, editable: false });
    aclRules.push({ elementId: 'ManageIconPortfolios.customer', visible: true, editable: false });
    aclRules.push({ elementId: 'ManageIconPortfolios.downloadTemplate', visible: true, clickable: false });
  }
  if (user.role === context.getters.roleCliente || user.role === context.getters.roleGroup) {
    aclRules.push({ elementId: 'ManageIconPortfolios.agencyCode', visible: true, editable: false });
    aclRules.push({ elementId: 'ManageIconPortfolios.customer', visible: true, editable: false });
    aclRules.push({ elementId: 'ManageIconPortfolios.downloadTemplate', visible: true, clickable: false });
  }
  if (user.role === context.getters.roleBroker) {
    aclRules.push({ elementId: 'ManageIconPortfolios.agencyCode', visible: true, editable: false });
    aclRules.push({ elementId: 'ManageIconPortfolios.customer', visible: true, editable: false });
    aclRules.push({ elementId: 'ManageIconPortfolios.downloadTemplate', visible: true, clickable: false });
  }
  context.commit('setAclRules', aclRules);
}

function iconPortfolios_ACL(context, user) {
  const aclRules = context.state.aclRules;
  if (user.role === context.getters.roleAgente) {
    aclRules.push({ elementId: 'IconPortfolios.companyName', visible: true, editable: false });
    aclRules.push({ elementId: 'IconPortfolios.iconContractNumber', visible: true, editable: false });
    aclRules.push({ elementId: 'IconPortfolios.email', visible: true, editable: false });
  }
  if (user.role === context.getters.roleCliente || user.role === context.getters.roleGroup) {
    aclRules.push({ elementId: 'IconPortfolios.companyName', visible: true, editable: false });
    aclRules.push({ elementId: 'IconPortfolios.iconContractNumber', visible: true, editable: false });
    aclRules.push({ elementId: 'IconPortfolios.email', visible: true, editable: false });
  }
  if (user.role === context.getters.roleBroker) {
    aclRules.push({ elementId: 'IconPortfolios.companyName', visible: true, editable: false });
    aclRules.push({ elementId: 'IconPortfolios.iconContractNumber', visible: true, editable: false });
    aclRules.push({ elementId: 'IconPortfolios.email', visible: true, editable: false });
  }
  context.commit('setAclRules', aclRules);
}

function tars_ACL(context, user) {
  const aclRules = context.state.aclRules;
  if (user.role === context.getters.roleAgente) {
    aclRules.push({ elementId: 'Tars.addDocument', visible: false });
    aclRules.push({ elementId: 'Tars.editDocument', visible: false });
    aclRules.push({ elementId: 'Tars.showInvalid', visible: false });
  }
  if (user.role === context.getters.roleCliente || user.role === context.getters.roleGroup) {
    aclRules.push({ elementId: 'Tars.addDocument', visible: false });
    aclRules.push({ elementId: 'Tars.editDocument', visible: false });
    aclRules.push({ elementId: 'Tars.showInvalid', visible: false });
  }
  if (user.role === context.getters.roleBroker) {

    aclRules.push({ elementId: 'Tars.addDocument', visible: false });
    aclRules.push({ elementId: 'Tars.editDocument', visible: false });
    aclRules.push({ elementId: 'Tars.showInvalid', visible: false });
  }
  context.commit('setAclRules', aclRules);
}

function userPreference_ACL(context, user) {
  const aclRules = context.state.aclRules;
  if (user.role === context.getters.roleBackoffice) {
    aclRules.push({ elementId: 'UserPreference.divisionBox', visible: true });
    aclRules.push({ elementId: 'UserPreference.flagSFTP', visible: true });
  }
  if (user.role === context.getters.roleAgente) {
    aclRules.push({ elementId: 'UserPreference.divisionBox', visible: false });
    aclRules.push({ elementId: 'UserPreference.flagSFTP', visible: false });
  }
  if (user.role === context.getters.roleCliente || user.role === context.getters.roleGroup) {
    aclRules.push({ elementId: 'UserPreference.divisionBox', visible: false });
    aclRules.push({ elementId: 'UserPreference.flagSFTP', visible: false });
  }
  if (user.role === context.getters.roleBroker) {
    aclRules.push({ elementId: 'UserPreference.divisionBox', visible: false });
    aclRules.push({ elementId: 'UserPreference.flagSFTP', visible: false });
  }
  context.commit('setAclRules', aclRules);
}
